import styled from 'styled-components';
import { useMutation } from '@apollo/client';
import { theme } from '../../styles/theme';
import {
  IUserSettingUpdateMutation,
  IUserSettingUpdateMutationVariables,
  UserSettingKind,
} from '../../utils/apollo/graphqlSchema';
import { USER_SETTING_UPDATE } from '../../utils/apollo/userSettings';
import printGraphqlErrors from '../../utils/apollo/printGraphqlErrors';
import { setColorSchema } from '../../redux/slices/userSettings';
import { useUserSettingsSelector } from '../../redux/selectorHooks';
import { useAppDispatch } from '../../redux/hooks';
import { useAnalytics } from '../../utils/analytics/useAnalytics';
import { toggleClicked } from '../../utils/analytics/events/toggle/events';
import SwitchiOS from '../SwitchiOS';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding-right: 12px;
  padding-left: 12px;
`;
const ToggleLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;

const DarkModeToggle = () => {
  const dispatch = useAppDispatch();
  const { track } = useAnalytics();
  const colorSchemaSetting = useUserSettingsSelector('colorSchemaSetting');

  const [saveSettings, { loading }] = useMutation<
    IUserSettingUpdateMutation,
    IUserSettingUpdateMutationVariables
  >(USER_SETTING_UPDATE);

  const toggleDarkMode = async () => {
    const value = colorSchemaSetting === 'LIGHT' ? 'DARK' : 'LIGHT';

    const response = await saveSettings({
      variables: {
        input: {
          userSettings: [
            {
              kind: UserSettingKind.ColorSchema,
              value,
            },
          ],
        },
      },
    });

    if (printGraphqlErrors(response?.data?.userSettingUpdate?.errors)) {
      return;
    }

    track(
      toggleClicked({
        name: 'dark mode',
        state: value === 'DARK',
      }),
    );

    dispatch(setColorSchema(value));
  };

  return (
    <Container>
      <ToggleLabel>Dark Mode</ToggleLabel>
      <SwitchiOS
        onClick={toggleDarkMode}
        isChecked={colorSchemaSetting === 'DARK'}
        isDisabled={loading}
      />
    </Container>
  );
};

export default DarkModeToggle;
